import { SyntheticEvent } from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import { TabMenu } from "../../types";
import CustomChip from "./CustomChip";

type ToggleChipGroupProps = {
    active: string;
    tabsMenu: TabMenu[];
    handleChange: (e: SyntheticEvent, value: string) => void;
};

export default function CustomToggleChipGroup(props: ToggleChipGroupProps) {
    const { active, tabsMenu, handleChange } = props;
    return (
        <Tabs
            value={active}
            onChange={handleChange}
            TabIndicatorProps={{
                style: {
                    display: "none",
                    fontWeight: "600",
                },
            }}
            sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "0.5rem",

                ".MuiTabs-flexContainer": {
                    flexFlow: "row wrap",
                    alignItems: "flex-start",
                    gap: "0.5rem",
                },
            }}
        >
            {tabsMenu.map((menuItem: TabMenu) => {
                const { key, name } = menuItem;
                const isActiveTab = active === key;

                const activeTabSx = isActiveTab
                    ? {
                          borderRadius: "1.25rem",

                          background: "#CCE6F8",
                          minHeight: "unset",
                      }
                    : {};

                return (
                    <Tab
                        label={
                            <CustomChip
                                label={
                                    <Typography
                                        sx={{
                                            overflow: "hidden",
                                            textAlign: "center",

                                            fontFamily: "Roboto",
                                            fontSize: "0.75rem",
                                            fontStyle: "normal",
                                            fontWeight: "500",
                                            lineHeight: "normal",
                                            color: "#023",
                                            minHeight: "unset",
                                            textTransform: "none",
                                        }}
                                    >
                                        {name}
                                    </Typography>
                                }
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "1.5rem",
                                    // minHeight: "unset",
                                    // border: "1px solid #C8CDD0",
                                    background: "#F3F5F6",
                                    borderRadius: "1.25rem",
                                    border: "none",
                                    "&:after": {
                                        display: "flex",
                                        height: "1.5rem",
                                        padding: "0.375rem 0.75rem",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                    },

                                    ...activeTabSx,
                                }}
                            />
                        }
                        key={key}
                        value={key}
                        sx={{
                            padding: 0,
                            minWidth: 0,
                            "&.Mui-selected": {
                                color: "#0082DE",
                            },
                        }}
                    />
                );
            })}
        </Tabs>
    );
}
